module.exports = __webpack_public_path__ + "static/media/Barmag 7a.bb60ff48.jpg";